import { media, P, TertiaryButton, TertiaryButtonProps } from 'ia-react-core';
import { Section } from 'omni-package-react-core';
import { FC } from 'react';
import styled from 'styled-components';

export const StyledSection = styled(Section)`
  display: table-cell;
  width: 100%;
`;

export const StyledButton = styled<FC<TertiaryButtonProps>>(TertiaryButton)`
  display: none;
  ${media.sm`
    margin-bottom: 5px;
    display: inline-block;
  `}
`;

export const StyledDivButton = styled.div`
  display: table-cell;
  vertical-align: middle;
`;

export const StyledP = styled(P)`
  margin-bottom: 0px;
`;
